export var ActionsTypes;
(function (ActionsTypes) {
    ActionsTypes["SUBSCRIBE"] = "CARDSFEED/SUBSCRIBE";
    ActionsTypes["ADDVALUE"] = "CARDSFEED/ADDVALUE";
})(ActionsTypes || (ActionsTypes = {}));
export const subscribeToCardsFeed = payload => {
    return {
        type: ActionsTypes.SUBSCRIBE,
        payload
    };
};
export const addCardValue = payload => {
    return {
        type: ActionsTypes.ADDVALUE,
        payload
    };
};
//# sourceMappingURL=actions.js.map